// extracted by mini-css-extract-plugin
module.exports = {"message":"useStaleBuildPrompt_message__AgCP_","refresh_button":"useStaleBuildPrompt_refresh_button__2Is4v"};